import { baseApi as api } from './api.base.js';
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    botMessagesControllerListBotMessagesV1: build.query<
      BotMessagesControllerListBotMessagesV1ApiResponse,
      BotMessagesControllerListBotMessagesV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/bot-messages`,
        params: {
          page: queryArg.page,
          limit: queryArg.limit,
          groupChatId: queryArg.groupChatId,
          groupName: queryArg.groupName,
          dateFrom: queryArg.dateFrom,
          dateTo: queryArg.dateTo,
          search: queryArg.search,
          sort: queryArg.sort,
        },
      }),
    }),
    botGroupsControllerListBotGroupsV1: build.query<
      BotGroupsControllerListBotGroupsV1ApiResponse,
      BotGroupsControllerListBotGroupsV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/bot-groups`,
        params: {
          search: queryArg.search,
          limit: queryArg.limit,
        },
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as generatedApi };
export type BotMessagesControllerListBotMessagesV1ApiResponse =
  /** status 200 Returns the paginated list of bot messages */ ListBotMessagesResponse;
export type BotMessagesControllerListBotMessagesV1ApiArg = {
  page?: number;
  limit?: number;
  groupChatId?: string;
  groupName?: string;
  dateFrom?: string;
  dateTo?: string;
  search?: string;
  sort?: 'date:asc' | 'date:desc';
};
export type BotGroupsControllerListBotGroupsV1ApiResponse =
  /** status 200 Returns the groups ordered by their latest message date, capped at `limit` (default 50) */ ListBotGroupsResponse;
export type BotGroupsControllerListBotGroupsV1ApiArg = {
  search?: string;
  limit?: number;
};
export type ListBotMessagesResponse = {
  data: {
    id: number;
    groupChatId: string;
    groupName: string;
    fromChatId: string;
    fromName: string;
    fromUsername: null | string;
    text: string;
    date: string;
  }[];
  total: number;
  page: number;
  limit: number;
};
export type ListBotGroupsResponse = {
  data: {
    groupChatId: string;
    groupName: string;
    date: string;
    status: 'active' | 'inactive';
  }[];
};
